// @mui
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
//
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

type Props = {
  title: string;
  onBack?: () => void;
};

export default function StepTitle({ title, onBack }: Props) {
  return (
    <Stack direction="row" alignItems="center" spacing={0.5} sx={{ ml: onBack ? -1 : 0 }}>
      {onBack && (
        <IconButton size="small" onClick={onBack} aria-label="Back" data-testid="wizard-back">
          <Iconify icon="eva:arrow-ios-back-fill" width={26} sx={{ color: 'text.primary' }} />
        </IconButton>
      )}
      <Typography variant="h5">{title}</Typography>
    </Stack>
  );
}
